import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { language } from './Settings'

const resources = {
  en: {
    translation: {
      'Vratky a reklamace': 'Returns and claims',
      'Reklamace': 'Claims',
      'Reklamace zboží.' : 'Submit a warranty claim',
      'Pokračovat': 'Continue',
      'Vratka': 'Return',
      'Vrácení zboží.' : 'Return your products',
      'Číslo objednávky nebo faktury' : 'Order or invoice number',
      'Email, pod kterým jste objednávali' : 'The email you ordered with',
      'Bez emailu (koupeno osobně na prodejně)' : 'No email (bought in person at the store)',
      'jmeno@domena.cz' : 'name@domain.com',
      'Nesprávný email' : 'Wrong email',
      'Objednávka nenalezena': 'Order not found',
      'Není zadáno číslo objednávky': 'Order number not entered',
      'Není zadán email': 'Email not entered',
      'Nesprávně zadané číslo dokladu': 'Incorrect document number',
      'Objednávka byla s emailem, prosíme zadejte jej' : 'Order was made with an email, please enter it',
      'Objednávka byla rozdělena na více faktur. Prosím zadejte či vyberte jednu z nich:' : 'The order has been split into multiple invoices. Please enter or select one of them:',
      'Zpět': 'Back',
      'Prosíme vyberte reklamované produkty' : 'Please select products you wish to claim',
      'Prosíme vyberte vracené produkty': 'Please select products you wish to return',
      'Nevracet': 'Don\'t return',
      'Vrátit': 'Return',
      'Koupeno ks:' : 'Pieces bought:',
      'Zahrnuto do reklamace / vratky' : 'Included in the claim / return',
      'Zahrnuto do vratky': 'Included in the return',
      'Zahrnuto do reklamace': 'Included in the claim',
      'Počet ks:' : 'Number of pieces:',
      'Vyberte alespoň jeden produkt' : 'Please select at least one product',
      'Zadejte množství produktu': 'Please enter the quantity of the product',
      'Bez důvodu do 14ti dní (pouze koncový zákazník)' : 'Without specifying a reason within 14 days (end customer only)' ,
      'Poškozeno při přepravě' : 'Damaged during transport',
      'Chyba na straně Bola spol s.r.o.' : 'An error on the part of Bola spol s.r.o.',
      'Chyba na straně zákazníka': 'Error on the customer\'s side',
      'Jiný': 'Other',
      'Vratka byla vytvořena.': 'The return was created.',
      'Reklamace byla vytvořena.': 'The claim has been created.',
      'Prosím zašlete či doručte balík na adresu:': 'Please send or deliver the package to:',
      'Pokud po vás dopravce požaduje telefonní číslo, uveďte +420 778 710 207.' : 'If the carrier requires a phone number, enter +420 778 710 207.',
      'Vepište na štítek/balík:' : 'Write on the label / package:',
      'Vytisknout štítek na balík' : 'Print package label',
      'Důvod reklamace': 'The reason for the claim',
      'Rozepište důvod reklamace': 'Describe the reason for the claim',
      'Číslo účtu pro případné vrácení peněz': 'Account number for any refunds',
      'IBAN číslo účtu pro případné vrácení peněz': 'IBAN account number for any refunds',
      'Prosím popište důvod reklamace zboží.': 'Please describe the reason for the claim.',
      'Prosím zadejte číslo účtu.': 'Please enter an account number.',
      'Prosím zadejte IBAN číslo účtu.': 'Please enter an IBAN account number.',
      'Souhrn vratky': 'Return summary',
      'Souhrn reklamace': 'Claim summary',
      'Co provádíte:': 'Your action',
      'Číslo objednávky:': 'Order number',
      'E-mail:': 'E-mail:',
      'Produkty, které vracíte či reklamujete:': 'Products to claim or return:',
      'Důvod vrácení či reklamace:': 'The reason for the claim or return:',
      'Rozepište důvod vrácení či reklamace:': 'Describe the reason for the return or claim:',
      'IBAN číslo účtu pro případné vrácení peněz:': 'IBAN account number for any refunds',
      'Odeslat': 'Submit',
      'Číslo účtu pro případné vrácení peněz:': 'Bank account number for any refunds:',
      'Kontaktní jméno:' : 'Contact name',
      'Kontaktní telefon:': 'Contact phone',
      'Kontaktní email:': 'Contact email',
      'Důvod vratky': 'Reason for the return',
      'Důvod vrácení': 'Reason for the return',
      'Prosíme rozepište důvod vrácení': 'Please specify the reason for the return',
      'Prosím popište důvod vrácení zboží.': 'Please specify the reason for returning your items.',
      'Bez čísla účtu' : 'No account number',
      'Nespravný IBAN. Zadejte jej prosím ve formátu XX1111111111 a zkontrolujte na překlepy.': 'Incorrect IBAN. Please enter it in the format XX1111111111 and check for typos.',
      'Jméno': 'Name',
      'Telefon': 'Phone',
      'Kontaktní údaje': 'Contact details',
      'Prosím vyplňte kontaktní jméno.' : 'Please enter contact name.',
      'Prosím vyplňte kontaktní telefon.' : 'Please enter contact phone.',
      'Prosím vyplňte kontaktní email.': 'Please enter contact email.',
      'Označit k reklamaci': 'Select for claiming',
      'Označit k vrácení': 'Select for returning',
      'Zrušit': 'Cancel',
      'Speciální podmínky domluvené se zástupcem Bola': 'Special conditions arranged with Bola representative',
      'Uveďte jméno zástupce a domluvené podmínky': 'State the name of the representative and arranged conditions',
      'Prosím uveďte jméno zástupce a domluvené podmínky.': 'Please state the name of the representative and arranged conditions.',
      'Speciální podmínky domluvené se zástupcem Bola:': 'Special conditions arranged with Bola representative:',
      'Produkt ponechte v originální krabičce a tu zabalte do přepravní krabice (aby se nepoškodila krabice produktu).': 'Keep the product in its original box and wrap it in a shipping box (to prevent damage to the product box).',
      'Zadejte platný email ve formátu jmeno@domena.cz': 'Please enter a valid email in the format name@domain.com'
    }
  },
  sk: {
    translation: {
      'Vratky a reklamace': 'Vratky a reklamácia',
      'Reklamace': 'Reklamácia',
      'Reklamace zboží.' : 'Reklamácia tovaru',
      'Pokračovat': 'Pokračovať',
      'Vratka': 'Vratka',
      'Vrácení zboží.' : 'Vrátenie tovaru',
      'Číslo objednávky nebo faktury' : 'Číslo objednávky alebo faktúry',
      'Email, pod kterým jste objednávali' : 'Email, pod ktorým ste objednávali',
      'Bez emailu (koupeno osobně na prodejně)' : 'Bez emailu (kúpené osobne na predajni)',
      'jmeno@domena.cz' : 'meno@domena.sk',
      'Nesprávný email' : 'Nesprávný email',
      'Objednávka nenalezena': 'Objednávka nenájdená',
      'Není zadáno číslo objednávky': 'Nie je zadané číslo objednávky',
      'Není zadán email': 'Nie je zadaný email',
      'Nesprávně zadané číslo dokladu': 'Nesprávne zadané číslo dokladu',
      'Objednávka byla s emailem, prosíme zadejte jej' : 'Objednávka bola s emailom, prosíme zadajte ho',
      'Objednávka byla rozdělena na více faktur. Prosím zadejte či vyberte jednu z nich:' : 'Objednávka bola rozdelená na viac faktúr. Prosím zadajte alebo vyberte jednu z nich:',
      'Zpět': 'Späť',
      'Prosíme vyberte reklamované produkty' : 'Prosíme vyberte reklamované produkty',
      'Prosíme vyberte vracené produkty': 'Prosíme vyberte vracané produkty',
      'Nevracet': 'Nevracať',
      'Vrátit': 'Vrátiť',
      'Koupeno ks:' : 'Kúpené ks:',
      'Zahrnuto do reklamace / vratky' : 'Zahrnuté do reklamácie / vratky',
      'Zahrnuto do vratky': 'Zahrnuté do vratky',
      'Zahrnuto do reklamace': 'Zahrnuté do reklamácie',
      'Počet ks:' : 'Počet ks:',
      'Vyberte alespoň jeden produkt' : 'Vyberte aspoň jeden produkt',
      'Zadejte množství produktu': 'Zadajte množstvo produktu',
      'Bez důvodu do 14ti dní (pouze koncový zákazník)' : 'Bez dôvodu do 14tich dní (len koncový zákazník)' ,
      'Poškozeno při přepravě' : 'Poškodené pri preprave',
      'Chyba na straně Bola spol s.r.o.' : 'Chyba na strane Bola spol s.r.o.',
      'Chyba na straně zákazníka': 'Chyba na strane zákazníka',
      'Jiný': 'Iný',
      'Vratka byla vytvořena.': 'Vratka bola vytvorená.',
      'Reklamace byla vytvořena.': 'Reklamácia bola vytvorená.',
      'Prosím zašlete či doručte balík na adresu:': 'Prosím zašlite či doručte balík na adresu:',
      'Pokud po vás dopravce požaduje telefonní číslo, uveďte +420 778 710 207.' : 'Ak od vás dopravca vyžaduje telefónne číslo, uveďte +420 778 710 207.',
      'Vepište na štítek/balík:' : 'Vpíšte na štítok/balík:',
      'Vytisknout štítek na balík' : 'Vytlačiť štítok na balík',
      'Důvod reklamace': 'Dôvod reklamácie',
      'Rozepište důvod reklamace': 'Rozpíšte dôvod reklamácie',
      'Číslo účtu pro případné vrácení peněz': 'Číslo účtu pre prípadné vrátenie peňazí',
      'IBAN číslo účtu pro případné vrácení peněz': 'IBAN číslo účtu pre prípadné vrátenie peňazí',
      'Prosím popište důvod reklamace zboží.': 'Prosím popíšte dôvod reklamácie tovaru.',
      'Prosím zadejte číslo účtu.': 'Prosím zadajte číslo účtu.',
      'Prosím zadejte IBAN číslo účtu.': 'Prosím zadajte IBAN číslo účtu.',
      'Souhrn vratky': 'Súhrn vratky',
      'Souhrn reklamace': 'Súhrn reklamácie',
      'Co provádíte:': 'Čo robíte:',
      'Číslo objednávky:': 'Číslo objednávky:',
      'E-mail:': 'E-mail:',
      'Produkty, které vracíte či reklamujete:': 'Produkty, ktoré vraciate či reklamujete:',
      'Důvod vrácení či reklamace:': 'Dôvod vrátenia či reklamácie:',
      'Rozepište důvod vrácení či reklamace:': 'Rozpíšte dôvod vrátenia či reklamácie:',
      'IBAN číslo účtu pro případné vrácení peněz:': 'IBAN číslo účtu pre prípadné vrátenie peňazí:',
      'Odeslat': 'Odoslať',
      'Číslo účtu pro případné vrácení peněz:': 'Číslo účtu pre prípadné vrátenie peňazí:',
      'Kontaktní jméno:' : 'Kontaktné meno:',
      'Kontaktní telefon:': 'Kontaktný telefón:',
      'Kontaktní email:': 'Kontaktný email:',
      'Důvod vratky': 'Dôvod vratky',
      'Důvod vrácení': 'Dôvod vrátenia',
      'Prosíme rozepište důvod vrácení': 'Prosíme rozpíšte dôvod vrátenia',
      'Prosím popište důvod vrácení zboží.': 'Prosím popíšte dôvod vrátenia tovaru.',
      'Bez čísla účtu' : 'Bez čísla účtu',
      'Nespravný IBAN. Zadejte jej prosím ve formátu XX1111111111 a zkontrolujte na překlepy.': 'Nespravný IBAN. Zadajte ho prosím vo formáte XX1111111111 a skontrolujte na preklepy.',
      'Jméno': 'Meno',
      'Telefon': 'Telefón',
      'Kontaktní údaje': 'Kontaktné údaje',
      'Prosím vyplňte kontaktní jméno.' : 'Prosím vyplňte kontaktné meno.',
      'Prosím vyplňte kontaktní telefon.' : 'Prosím vyplňte kontaktný telefón.',
      'Prosím vyplňte kontaktní email.': 'Prosím vyplňte kontaktný email.',
      'Označit k reklamaci': 'Označiť na reklamáciu',
      'Označit k vrácení': 'Označiť na vrátenie',
      'Zrušit': 'Zrušiť',
      'Speciální podmínky domluvené se zástupcem Bola': 'Špeciálne podmienky dohodnuté so zástupcom Bola',
      'Uveďte jméno zástupce a domluvené podmínky': 'Uveďte meno zástupcu a dohodnuté podmienky',
      'Prosím uveďte jméno zástupce a domluvené podmínky.': 'Prosím uveďte meno zástupcu a dohodnuté podmienky.',
      'Speciální podmínky domluvené se zástupcem Bola:': 'Špeciálne podmienky dohodnuté so zástupcom Bola:',
      'Produkt ponechte v originální krabičce a tu zabalte do přepravní krabice (aby se nepoškodila krabice produktu).': 'Produkt ponechajte v originálnej krabičke a tú zabaľte do prepravnej krabice (aby sa nepoškodila krabica produktu).',
      'Zadejte platný email ve formátu jmeno@domena.cz': 'Zadajte platný email vo formáte meno@domena.sk'
    }
  },
  fr: {
    translation: {
      'Vratky a reklamace': 'Retours et réclamations',
      'Reklamace': 'Réclamations',
      'Reklamace zboží.': 'Faire une réclamation',
      'Pokračovat': 'Continuer',
      'Vratka': 'Retour',
      'Vrácení zboží.': 'Retournez vos produits',
      'Číslo objednávky nebo faktury': 'Numéro de commande ou de facture',
      'Email, pod kterým jste objednávali': 'L\'email avec lequel vous avez commandé',
      'Bez emailu (koupeno osobně na prodejně)': 'Sans email (acheté en personne en magasin)',
      'jmeno@domena.cz': 'nom@domaine.fr',
      'Nesprávný email': 'Email incorrect',
      'Objednávka nenalezena': 'Commande introuvable',
      'Není zadáno číslo objednávky': 'Numéro de commande non saisi',
      'Není zadán email': 'Email non saisi',
      'Nesprávně zadané číslo dokladu': 'Numéro de document incorrect',
      'Objednávka byla s emailem, prosíme zadejte jej': 'La commande a été passée avec un email, veuillez le saisir',
      'Objednávka byla rozdělena na více faktur. Prosím zadejte či vyberte jednu z nich:': 'La commande a été divisée en plusieurs factures. Veuillez saisir ou sélectionner l\'une d\'elles:',
      'Zpět': 'Retour',
      'Prosíme vyberte reklamované produkty': 'Veuillez sélectionner les produits à réclamer',
      'Prosíme vyberte vracené produkty': 'Veuillez sélectionner les produits à retourner',
      'Nevracet': 'Ne pas retourner',
      'Vrátit': 'Retourner',
      'Koupeno ks:': 'Quantité achetée:',
      'Zahrnuto do reklamace / vratky': 'Inclus dans la réclamation / le retour',
      'Zahrnuto do vratky': 'Inclus dans le retour',
      'Zahrnuto do reklamace': 'Inclus dans la réclamation',
      'Počet ks:': 'Nombre de pièces:',
      'Vyberte alespoň jeden produkt': 'Veuillez sélectionner au moins un produit',
      'Zadejte množství produktu': 'Veuillez saisir la quantité du produit',
      'Bez důvodu do 14ti dní (pouze koncový zákazník)': 'Sans raison sous 14 jours (client final uniquement)',
      'Poškozeno při přepravě': 'Endommagé pendant le transport',
      'Chyba na straně Bola spol s.r.o.': 'Erreur de la part de Bola spol s.r.o.',
      'Chyba na straně zákazníka': 'Erreur du côté du client',
      'Jiný': 'Autre',
      'Vratka byla vytvořena.': 'Le retour a été créé.',
      'Reklamace byla vytvořena.': 'La réclamation a été créée.',
      'Prosím zašlete či doručte balík na adresu:': 'Veuillez envoyer ou livrer le colis à l\'adresse:',
      'Pokud po vás dopravce požaduje telefonní číslo, uveďte +420 778 710 207.': 'Si le transporteur demande un numéro de téléphone, indiquez le +420 778 710 207.',
      'Vepište na štítek/balík:': 'Inscrivez sur l\'étiquette / le colis:',
      'Vytisknout štítek na balík': 'Imprimer l\'étiquette du colis',
      'Důvod reklamace': 'Motif de la réclamation',
      'Rozepište důvod reklamace': 'Décrivez le motif de la réclamation',
      'Číslo účtu pro případné vrácení peněz': 'Numéro de compte pour un éventuel remboursement',
      'IBAN číslo účtu pro případné vrácení peněz': 'Numéro de compte IBAN pour un éventuel remboursement',
      'Prosím popište důvod reklamace zboží.': 'Veuillez décrire le motif de la réclamation du produit.',
      'Prosím zadejte číslo účtu.': 'Veuillez saisir le numéro de compte.',
      'Prosím zadejte IBAN číslo účtu.': 'Veuillez saisir le numéro de compte IBAN.',
      'Souhrn vratky': 'Résumé du retour',
      'Souhrn reklamace': 'Résumé de la réclamation',
      'Co provádíte:': 'Action en cours:',
      'Číslo objednávky:': 'Numéro de commande:',
      'E-mail:': 'E-mail:',
      'Produkty, které vracíte či reklamujete:': 'Produits que vous retournez ou réclamez:',
      'Důvod vrácení či reklamace:': 'Motif du retour ou de la réclamation:',
      'Rozepište důvod vrácení či reklamace:': 'Décrivez le motif du retour ou de la réclamation:',
      'IBAN číslo účtu pro případné vrácení peněz:': 'Numéro de compte IBAN pour un éventuel remboursement:',
      'Odeslat': 'Envoyer',
      'Číslo účtu pro případné vrácení peněz:': 'Numéro de compte pour un éventuel remboursement:',
      'Kontaktní jméno:': 'Nom du contact:',
      'Kontaktní telefon:': 'Téléphone du contact:',
      'Kontaktní email:': 'Email du contact:',
      'Důvod vratky': 'Motif du retour',
      'Důvod vrácení': 'Motif du retour',
      'Prosíme rozepište důvod vrácení': 'Veuillez préciser le motif du retour',
      'Prosím popište důvod vrácení zboží.': 'Veuillez préciser le motif du retour des articles.',
      'Bez čísla účtu': 'Sans numéro de compte',
      'Nespravný IBAN. Zadejte jej prosím ve formátu XX1111111111 a zkontrolujte na překlepy.': 'IBAN incorrect. Veuillez le saisir au format XX1111111111 et vérifier les fautes de frappe.',
      'Jméno': 'Nom',
      'Telefon': 'Téléphone',
      'Kontaktní údaje': 'Coordonnées',
      'Prosím vyplňte kontaktní jméno.': 'Veuillez saisir le nom du contact.',
      'Prosím vyplňte kontaktní telefon.': 'Veuillez saisir le téléphone du contact.',
      'Prosím vyplňte kontaktní email.': 'Veuillez saisir l\'email du contact.',
      'Označit k reklamaci': 'Sélectionner pour réclamation',
      'Označit k vrácení': 'Sélectionner pour retour',
      'Zrušit': 'Annuler',
      'Speciální podmínky domluvené se zástupcem Bola': 'Conditions spéciales convenues avec le représentant Bola',
      'Uveďte jméno zástupce a domluvené podmínky': 'Indiquez le nom du représentant et les conditions convenues',
      'Prosím uveďte jméno zástupce a domluvené podmínky.': 'Veuillez indiquer le nom du représentant et les conditions convenues.',
      'Speciální podmínky domluvené se zástupcem Bola:': 'Conditions spéciales convenues avec le représentant Bola :',
      'Produkt ponechte v originální krabičce a tu zabalte do přepravní krabice (aby se nepoškodila krabice produktu).': 'Laissez le produit dans sa boîte d\'origine et emballez-la dans un carton d\'expédition (pour éviter d\'endommager la boîte du produit)',
      'Zadejte platný email ve formátu jmeno@domena.cz': 'Veuillez saisir un email valide au format nom@domaine.fr'
    }
  },
  de: {
    translation: {
      'Vratky a reklamace': 'Rücksendungen und Reklamationen',
      'Reklamace': 'Reklamationen',
      'Reklamace zboží.': 'Reklamation einreichen',
      'Pokračovat': 'Weiter',
      'Vratka': 'Rücksendung',
      'Vrácení zboží.': 'Waren zurücksenden',
      'Číslo objednávky nebo faktury': 'Bestell- oder Rechnungsnummer',
      'Email, pod kterým jste objednávali': 'E-Mail, mit der Sie bestellt haben',
      'Bez emailu (koupeno osobně na prodejně)': 'Ohne E-Mail (persönlich im Geschäft gekauft)',
      'jmeno@domena.cz': 'name@domain.de',
      'Nesprávný email': 'Falsche E-Mail',
      'Objednávka nenalezena': 'Bestellung nicht gefunden',
      'Není zadáno číslo objednávky': 'Bestellnummer nicht eingegeben',
      'Není zadán email': 'E-Mail nicht eingegeben',
      'Nesprávně zadané číslo dokladu': 'Falsche Dokumentennummer',
      'Objednávka byla s emailem, prosíme zadejte jej': 'Die Bestellung wurde mit einer E-Mail aufgegeben, bitte geben Sie diese ein',
      'Objednávka byla rozdělena na více faktur. Prosím zadejte či vyberte jednu z nich:': 'Die Bestellung wurde in mehrere Rechnungen aufgeteilt. Bitte geben Sie eine davon ein oder wählen Sie eine aus:',
      'Zpět': 'Zurück',
      'Prosíme vyberte reklamované produkty': 'Bitte wählen Sie die zu reklamierenden Produkte aus',
      'Prosíme vyberte vracené produkty': 'Bitte wählen Sie die zurückzusendenden Produkte aus',
      'Nevracet': 'Nicht zurücksenden',
      'Vrátit': 'Zurücksenden',
      'Koupeno ks:': 'Gekaufte Stück:',
      'Zahrnuto do reklamace / vratky': 'In Reklamation / Rücksendung enthalten',
      'Zahrnuto do vratky': 'In Rücksendung enthalten',
      'Zahrnuto do reklamace': 'In Reklamation enthalten',
      'Počet ks:': 'Anzahl der Stücke:',
      'Vyberte alespoň jeden produkt': 'Bitte wählen Sie mindestens ein Produkt aus',
      'Zadejte množství produktu': 'Bitte geben Sie die Menge des Produkts ein',
      'Bez důvodu do 14ti dní (pouze koncový zákazník)': 'Ohne Angabe von Gründen innerhalb von 14 Tagen (nur Endkunde)',
      'Poškozeno při přepravě': 'Beim Transport beschädigt',
      'Chyba na straně Bola spol s.r.o.': 'Fehler seitens Bola spol s.r.o.',
      'Chyba na straně zákazníka': 'Fehler auf Kundenseite',
      'Jiný': 'Andere',
      'Vratka byla vytvořena.': 'Die Rücksendung wurde erstellt.',
      'Reklamace byla vytvořena.': 'Die Reklamation wurde erstellt.',
      'Prosím zašlete či doručte balík na adresu:': 'Bitte senden oder liefern Sie das Paket an die Adresse:',
      'Pokud po vás dopravce požaduje telefonní číslo, uveďte +420 778 710 207.': 'Falls der Zusteller eine Telefonnummer verlangt, geben Sie +420 778 710 207 an.',
      'Vepište na štítek/balík:': 'Schreiben Sie auf das Etikett / Paket:',
      'Vytisknout štítek na balík': 'Paketetikett drucken',
      'Důvod reklamace': 'Grund der Reklamation',
      'Rozepište důvod reklamace': 'Beschreiben Sie den Grund der Reklamation',
      'Číslo účtu pro případné vrácení peněz': 'Kontonummer für eventuelle Rückerstattung',
      'IBAN číslo účtu pro případné vrácení peněz': 'IBAN-Kontonummer für eventuelle Rückerstattung',
      'Prosím popište důvod reklamace zboží.': 'Bitte beschreiben Sie den Grund der Reklamation.',
      'Prosím zadejte číslo účtu.': 'Bitte geben Sie die Kontonummer ein.',
      'Prosím zadejte IBAN číslo účtu.': 'Bitte geben Sie die IBAN-Kontonummer ein.',
      'Souhrn vratky': 'Zusammenfassung der Rücksendung',
      'Souhrn reklamace': 'Zusammenfassung der Reklamation',
      'Co provádíte:': 'Ihre Aktion:',
      'Číslo objednávky:': 'Bestellnummer:',
      'E-mail:': 'E-Mail:',
      'Produkty, které vracíte či reklamujete:': 'Produkte, die Sie zurücksenden oder reklamieren:',
      'Důvod vrácení či reklamace:': 'Grund der Rücksendung oder Reklamation:',
      'Rozepište důvod vrácení či reklamace:': 'Beschreiben Sie den Grund der Rücksendung oder Reklamation:',
      'IBAN číslo účtu pro případné vrácení peněz:': 'IBAN-Kontonummer für eventuelle Rückerstattung:',
      'Odeslat': 'Absenden',
      'Číslo účtu pro případné vrácení peněz:': 'Kontonummer für eventuelle Rückerstattung:',
      'Kontaktní jméno:': 'Kontaktname:',
      'Kontaktní telefon:': 'Kontakttelefon:',
      'Kontaktní email:': 'Kontakt-E-Mail:',
      'Důvod vratky': 'Grund der Rücksendung',
      'Důvod vrácení': 'Grund der Rücksendung',
      'Prosíme rozepište důvod vrácení': 'Bitte geben Sie den Grund der Rücksendung an',
      'Prosím popište důvod vrácení zboží.': 'Bitte beschreiben Sie den Grund für die Rücksendung der Artikel.',
      'Bez čísla účtu': 'Ohne Kontonummer',
      'Nespravný IBAN. Zadejte jej prosím ve formátu XX1111111111 a zkontrolujte na překlepy.': 'Falsche IBAN. Bitte geben Sie sie im Format XX1111111111 ein und prüfen Sie auf Tippfehler.',
      'Jméno': 'Name',
      'Telefon': 'Telefon',
      'Kontaktní údaje': 'Kontaktdaten',
      'Prosím vyplňte kontaktní jméno.': 'Bitte geben Sie den Kontaktnamen ein.',
      'Prosím vyplňte kontaktní telefon.': 'Bitte geben Sie die Kontakttelefonnummer ein.',
      'Prosím vyplňte kontaktní email.': 'Bitte geben Sie die Kontakt-E-Mail ein.',
      'Označit k reklamaci': 'Zur Reklamation markieren',
      'Označit k vrácení': 'Zur Rücksendung markieren',
      'Zrušit': 'Abbrechen',
      'Speciální podmínky domluvené se zástupcem Bola': 'Sonderbedingungen mit dem Bola-Vertreter vereinbart',
      'Uveďte jméno zástupce a domluvené podmínky': 'Geben Sie den Namen des Vertreters und die vereinbarten Bedingungen an',
      'Prosím uveďte jméno zástupce a domluvené podmínky.': 'Bitte geben Sie den Namen des Vertreters und die vereinbarten Bedingungen an.',
      'Speciální podmínky domluvené se zástupcem Bola:': 'Sonderbedingungen mit dem Bola-Vertreter vereinbart:',
      'Produkt ponechte v originální krabičce a tu zabalte do přepravní krabice (aby se nepoškodila krabice produktu).': 'Lassen Sie das Produkt in der Originalverpackung und packen Sie diese in einen Versandkarton (um Beschädigungen der Produktverpackung zu vermeiden).',
      'Zadejte platný email ve formátu jmeno@domena.cz': 'Bitte geben Sie eine gültige E-Mail im Format name@domain.de ein'
    }
  },
  nl: {
    translation: {
      'Vratky a reklamace': 'Retouren en claims',
      'Reklamace': 'Claims',
      'Reklamace zboží.': 'Claim indienen',
      'Pokračovat': 'Doorgaan',
      'Vratka': 'Retour',
      'Vrácení zboží.': 'Producten retourneren',
      'Číslo objednávky nebo faktury': 'Bestelling- of factuurnummer',
      'Email, pod kterým jste objednávali': 'E-mailadres waarmee u heeft besteld',
      'Bez emailu (koupeno osobně na prodejně)': 'Zonder e-mail (persoonlijk gekocht in de winkel)',
      'jmeno@domena.cz': 'naam@domein.nl',
      'Nesprávný email': 'Verkeerd e-mailadres',
      'Objednávka nenalezena': 'Bestelling niet gevonden',
      'Není zadáno číslo objednávky': 'Bestellingnummer niet ingevoerd',
      'Není zadán email': 'E-mail niet ingevoerd',
      'Nesprávně zadané číslo dokladu': 'Onjuist documentnummer',
      'Objednávka byla s emailem, prosíme zadejte jej': 'Bestelling is gedaan met een e-mail, voer deze in',
      'Objednávka byla rozdělena na více faktur. Prosím zadejte či vyberte jednu z nich:': 'De bestelling is opgesplitst in meerdere facturen. Voer er een in of selecteer er een:',
      'Zpět': 'Terug',
      'Prosíme vyberte reklamované produkty': 'Selecteer de te claimen producten',
      'Prosíme vyberte vracené produkty': 'Selecteer de te retourneren producten',
      'Nevracet': 'Niet retourneren',
      'Vrátit': 'Retourneren',
      'Koupeno ks:': 'Gekochte stuks:',
      'Zahrnuto do reklamace / vratky': 'Opgenomen in claim / retour',
      'Zahrnuto do vratky': 'Opgenomen in retour',
      'Zahrnuto do reklamace': 'Opgenomen in claim',
      'Počet ks:': 'Aantal stuks:',
      'Vyberte alespoň jeden produkt': 'Selecteer ten minste één product',
      'Zadejte množství produktu': 'Voer de hoeveelheid van het product in',
      'Bez důvodu do 14ti dní (pouze koncový zákazník)': 'Zonder reden binnen 14 dagen (alleen eindklant)',
      'Poškozeno při přepravě': 'Beschadigd tijdens transport',
      'Chyba na straně Bola spol s.r.o.': 'Fout van Bola spol s.r.o.',
      'Chyba na straně zákazníka': 'Fout aan de kant van de klant',
      'Jiný': 'Andere',
      'Vratka byla vytvořena.': 'De retour is aangemaakt.',
      'Reklamace byla vytvořena.': 'De claim is aangemaakt.',
      'Prosím zašlete či doručte balík na adresu:': 'Stuur of lever het pakket naar het adres:',
      'Pokud po vás dopravce požaduje telefonní číslo, uveďte +420 778 710 207.': 'Als de vervoerder een telefoonnummer vraagt, vermeld dan +420 778 710 207.',
      'Vepište na štítek/balík:': 'Schrijf op het label / pakket:',
      'Vytisknout štítek na balík': 'Pakketlabel afdrukken',
      'Důvod reklamace': 'Reden van de claim',
      'Rozepište důvod reklamace': 'Beschrijf de reden van de claim',
      'Číslo účtu pro případné vrácení peněz': 'Rekeningnummer voor eventuele terugbetaling',
      'IBAN číslo účtu pro případné vrácení peněz': 'IBAN-rekeningnummer voor eventuele terugbetaling',
      'Prosím popište důvod reklamace zboží.': 'Beschrijf de reden van de claim.',
      'Prosím zadejte číslo účtu.': 'Voer het rekeningnummer in.',
      'Prosím zadejte IBAN číslo účtu.': 'Voer het IBAN-rekeningnummer in.',
      'Souhrn vratky': 'Samenvatting retour',
      'Souhrn reklamace': 'Samenvatting claim',
      'Co provádíte:': 'Uw actie:',
      'Číslo objednávky:': 'Bestellingnummer:',
      'E-mail:': 'E-mail:',
      'Produkty, které vracíte či reklamujete:': 'Producten die u retourneert of claimt:',
      'Důvod vrácení či reklamace:': 'Reden van retour of claim:',
      'Rozepište důvod vrácení či reklamace:': 'Beschrijf de reden van retour of claim:',
      'IBAN číslo účtu pro případné vrácení peněz:': 'IBAN-rekeningnummer voor eventuele terugbetaling:',
      'Odeslat': 'Verzenden',
      'Číslo účtu pro případné vrácení peněz:': 'Rekeningnummer voor eventuele terugbetaling:',
      'Kontaktní jméno:': 'Contactnaam:',
      'Kontaktní telefon:': 'Contacttelefoon:',
      'Kontaktní email:': 'Contact e-mail:',
      'Důvod vratky': 'Reden van retour',
      'Důvod vrácení': 'Reden van retour',
      'Prosíme rozepište důvod vrácení': 'Geef de reden van retour op',
      'Prosím popište důvod vrácení zboží.': 'Beschrijf de reden voor het retourneren van de artikelen.',
      'Bez čísla účtu': 'Zonder rekeningnummer',
      'Nespravný IBAN. Zadejte jej prosím ve formátu XX1111111111 a zkontrolujte na překlepy.': 'Onjuiste IBAN. Voer deze in het formaat XX1111111111 in en controleer op typefouten.',
      'Jméno': 'Naam',
      'Telefon': 'Telefoon',
      'Kontaktní údaje': 'Contactgegevens',
      'Prosím vyplňte kontaktní jméno.': 'Vul de contactnaam in.',
      'Prosím vyplňte kontaktní telefon.': 'Vul het contacttelefoonnummer in.',
      'Prosím vyplňte kontaktní email.': 'Vul het contact e-mailadres in.',
      'Označit k reklamaci': 'Markeren voor claim',
      'Označit k vrácení': 'Markeren voor retour',
      'Zrušit': 'Annuleren',
      'Speciální podmínky domluvené se zástupcem Bola': 'Speciale voorwaarden afgesproken met Bola-vertegenwoordiger',
      'Uveďte jméno zástupce a domluvené podmínky': 'Geef de naam van de vertegenwoordiger en afgesproken voorwaarden op',
      'Prosím uveďte jméno zástupce a domluvené podmínky.': 'Geef de naam van de vertegenwoordiger en afgesproken voorwaarden op.',
      'Speciální podmínky domluvené se zástupcem Bola:': 'Speciale voorwaarden afgesproken met Bola-vertegenwoordiger:',
      'Produkt ponechte v originální krabičce a tu zabalte do přepravní krabice (aby se nepoškodila krabice produktu).': 'Laat het product in de originele verpakking en verpak deze in een verzenddoos (om beschadiging van de productverpakking te voorkomen).',
      'Zadejte platný email ve formátu jmeno@domena.cz': 'Voer een geldig e-mailadres in het formaat naam@domein.nl in'
    }
  },
  it: {
    translation: {
      'Vratky a reklamace': 'Resi e reclami',
      'Reklamace': 'Reclami',
      'Reklamace zboží.': 'Presentare un reclamo',
      'Pokračovat': 'Continua',
      'Vratka': 'Reso',
      'Vrácení zboží.': 'Restituire i prodotti',
      'Číslo objednávky nebo faktury': 'Numero ordine o fattura',
      'Email, pod kterým jste objednávali': 'L\'email con cui hai ordinato',
      'Bez emailu (koupeno osobně na prodejně)': 'Senza email (acquistato di persona in negozio)',
      'jmeno@domena.cz': 'nome@dominio.it',
      'Nesprávný email': 'Email errata',
      'Objednávka nenalezena': 'Ordine non trovato',
      'Není zadáno číslo objednávky': 'Numero ordine non inserito',
      'Není zadán email': 'Email non inserita',
      'Nesprávně zadané číslo dokladu': 'Numero documento errato',
      'Objednávka byla s emailem, prosíme zadejte jej': 'L\'ordine è stato effettuato con un\'email, inseriscila',
      'Objednávka byla rozdělena na více faktur. Prosím zadejte či vyberte jednu z nich:': 'L\'ordine è stato suddiviso in più fatture. Inserisci o seleziona una di esse:',
      'Zpět': 'Indietro',
      'Prosíme vyberte reklamované produkty': 'Seleziona i prodotti da reclamare',
      'Prosíme vyberte vracené produkty': 'Seleziona i prodotti da restituire',
      'Nevracet': 'Non restituire',
      'Vrátit': 'Restituire',
      'Koupeno ks:': 'Pezzi acquistati:',
      'Zahrnuto do reklamace / vratky': 'Incluso nel reclamo / reso',
      'Zahrnuto do vratky': 'Incluso nel reso',
      'Zahrnuto do reklamace': 'Incluso nel reclamo',
      'Počet ks:': 'Numero di pezzi:',
      'Vyberte alespoň jeden produkt': 'Seleziona almeno un prodotto',
      'Zadejte množství produktu': 'Inserisci la quantità del prodotto',
      'Bez důvodu do 14ti dní (pouze koncový zákazník)': 'Senza motivo entro 14 giorni (solo cliente finale)',
      'Poškozeno při přepravě': 'Danneggiato durante il trasporto',
      'Chyba na straně Bola spol s.r.o.': 'Errore da parte di Bola spol s.r.o.',
      'Chyba na straně zákazníka': 'Errore da parte del cliente',
      'Jiný': 'Altro',
      'Vratka byla vytvořena.': 'Il reso è stato creato.',
      'Reklamace byla vytvořena.': 'Il reclamo è stato creato.',
      'Prosím zašlete či doručte balík na adresu:': 'Invia o consegna il pacco all\'indirizzo:',
      'Pokud po vás dopravce požaduje telefonní číslo, uveďte +420 778 710 207.': 'Se il corriere richiede un numero di telefono, indichi +420 778 710 207.',
      'Vepište na štítek/balík:': 'Scrivi sull\'etichetta / pacco:',
      'Vytisknout štítek na balík': 'Stampa etichetta pacco',
      'Důvod reklamace': 'Motivo del reclamo',
      'Rozepište důvod reklamace': 'Descrivi il motivo del reclamo',
      'Číslo účtu pro případné vrácení peněz': 'Numero di conto per eventuale rimborso',
      'IBAN číslo účtu pro případné vrácení peněz': 'Numero di conto IBAN per eventuale rimborso',
      'Prosím popište důvod reklamace zboží.': 'Descrivi il motivo del reclamo.',
      'Prosím zadejte číslo účtu.': 'Inserisci il numero di conto.',
      'Prosím zadejte IBAN číslo účtu.': 'Inserisci il numero di conto IBAN.',
      'Souhrn vratky': 'Riepilogo reso',
      'Souhrn reklamace': 'Riepilogo reclamo',
      'Co provádíte:': 'Azione in corso:',
      'Číslo objednávky:': 'Numero ordine:',
      'E-mail:': 'E-mail:',
      'Produkty, které vracíte či reklamujete:': 'Prodotti che restituisci o reclami:',
      'Důvod vrácení či reklamace:': 'Motivo del reso o reclamo:',
      'Rozepište důvod vrácení či reklamace:': 'Descrivi il motivo del reso o reclamo:',
      'IBAN číslo účtu pro případné vrácení peněz:': 'Numero di conto IBAN per eventuale rimborso:',
      'Odeslat': 'Invia',
      'Číslo účtu pro případné vrácení peněz:': 'Numero di conto per eventuale rimborso:',
      'Kontaktní jméno:': 'Nome contatto:',
      'Kontaktní telefon:': 'Telefono contatto:',
      'Kontaktní email:': 'Email contatto:',
      'Důvod vratky': 'Motivo del reso',
      'Důvod vrácení': 'Motivo del reso',
      'Prosíme rozepište důvod vrácení': 'Specifica il motivo del reso',
      'Prosím popište důvod vrácení zboží.': 'Descrivi il motivo della restituzione degli articoli.',
      'Bez čísla účtu': 'Senza numero di conto',
      'Nespravný IBAN. Zadejte jej prosím ve formátu XX1111111111 a zkontrolujte na překlepy.': 'IBAN errato. Inseriscilo nel formato XX1111111111 e controlla gli errori di battitura.',
      'Jméno': 'Nome',
      'Telefon': 'Telefono',
      'Kontaktní údaje': 'Dati di contatto',
      'Prosím vyplňte kontaktní jméno.': 'Inserisci il nome di contatto.',
      'Prosím vyplňte kontaktní telefon.': 'Inserisci il telefono di contatto.',
      'Prosím vyplňte kontaktní email.': 'Inserisci l\'email di contatto.',
      'Označit k reklamaci': 'Seleziona per reclamo',
      'Označit k vrácení': 'Seleziona per reso',
      'Zrušit': 'Annulla',
      'Speciální podmínky domluvené se zástupcem Bola': 'Condizioni speciali concordate con il rappresentante Bola',
      'Uveďte jméno zástupce a domluvené podmínky': 'Indica il nome del rappresentante e le condizioni concordate',
      'Prosím uveďte jméno zástupce a domluvené podmínky.': 'Indica il nome del rappresentante e le condizioni concordate.',
      'Speciální podmínky domluvené se zástupcem Bola:': 'Condizioni speciali concordate con il rappresentante Bola:',
      'Produkt ponechte v originální krabičce a tu zabalte do přepravní krabice (aby se nepoškodila krabice produktu).': 'Lascia il prodotto nella confezione originale e avvolgila in una scatola da spedizione (per evitare danni alla confezione del prodotto).',
      'Zadejte platný email ve formátu jmeno@domena.cz': 'Inserisci un\'email valida nel formato nome@dominio.it'
    }
  },
  ua: {
    translation: {
      'Vratky a reklamace': 'Повернення та скарги',
      'Reklamace': 'Скарги',
      'Reklamace zboží.': 'Подати скаргу',
      'Pokračovat': 'Продовжити',
      'Vratka': 'Повернення',
      'Vrácení zboží.': 'Повернути товари',
      'Číslo objednávky nebo faktury': 'Номер замовлення або рахунку',
      'Email, pod kterým jste objednávali': 'Електронна адреса, з якою ви замовляли',
      'Bez emailu (koupeno osobně na prodejně)': 'Без електронної пошти (куплено особисто в магазині)',
      'jmeno@domena.cz': 'імʼя@домен.ua',
      'Nesprávný email': 'Неправильна електронна адреса',
      'Objednávka nenalezena': 'Замовлення не знайдено',
      'Není zadáno číslo objednávky': 'Номер замовлення не введено',
      'Není zadán email': 'Електронна адреса не введена',
      'Nesprávně zadané číslo dokladu': 'Неправильний номер документа',
      'Objednávka byla s emailem, prosíme zadejte jej': 'Замовлення було зроблено з електронною поштою, будь ласка, введіть її',
      'Objednávka byla rozdělena na více faktur. Prosím zadejte či vyberte jednu z nich:': 'Замовлення було розділено на кілька рахунків. Будь ласка, введіть або виберіть один з них:',
      'Zpět': 'Назад',
      'Prosíme vyberte reklamované produkty': 'Виберіть товари для скарги',
      'Prosíme vyberte vracené produkty': 'Виберіть товари для повернення',
      'Nevracet': 'Не повертати',
      'Vrátit': 'Повернути',
      'Koupeno ks:': 'Куплено штук:',
      'Zahrnuto do reklamace / vratky': 'Включено до скарги / повернення',
      'Zahrnuto do vratky': 'Включено до повернення',
      'Zahrnuto do reklamace': 'Включено до скарги',
      'Počet ks:': 'Кількість штук:',
      'Vyberte alespoň jeden produkt': 'Виберіть принаймні один товар',
      'Zadejte množství produktu': 'Введіть кількість товару',
      'Bez důvodu do 14ti dní (pouze koncový zákazník)': 'Без причини протягом 14 днів (лише кінцевий клієнт)',
      'Poškozeno při přepravě': 'Пошкоджено під час транспортування',
      'Chyba na straně Bola spol s.r.o.': 'Помилка з боку Bola spol s.r.o.',
      'Chyba na straně zákazníka': 'Помилка з боку клієнта',
      'Jiný': 'Інше',
      'Vratka byla vytvořena.': 'Повернення створено.',
      'Reklamace byla vytvořena.': 'Скаргу створено.',
      'Prosím zašlete či doručte balík na adresu:': 'Будь ласка, надішліть або доставте посилку на адресу:',
      'Pokud po vás dopravce požaduje telefonní číslo, uveďte +420 778 710 207.': 'Якщо перевізник вимагає номер телефону, вкажіть +420 778 710 207.',
      'Vepište na štítek/balík:': 'Напишіть на етикетці / посилці:',
      'Vytisknout štítek na balík': 'Роздрукувати етикетку посилки',
      'Důvod reklamace': 'Причина скарги',
      'Rozepište důvod reklamace': 'Опишіть причину скарги',
      'Číslo účtu pro případné vrácení peněz': 'Номер рахунку для можливого повернення коштів',
      'IBAN číslo účtu pro případné vrácení peněz': 'Номер рахунку IBAN для можливого повернення коштів',
      'Prosím popište důvod reklamace zboží.': 'Опишіть причину скарги.',
      'Prosím zadejte číslo účtu.': 'Введіть номер рахунку.',
      'Prosím zadejte IBAN číslo účtu.': 'Введіть номер рахунку IBAN.',
      'Souhrn vratky': 'Підсумок повернення',
      'Souhrn reklamace': 'Підсумок скарги',
      'Co provádíte:': 'Ваша дія:',
      'Číslo objednávky:': 'Номер замовлення:',
      'E-mail:': 'E-mail:',
      'Produkty, které vracíte či reklamujete:': 'Товари, які ви повертаєте або скаржитесь:',
      'Důvod vrácení či reklamace:': 'Причина повернення або скарги:',
      'Rozepište důvod vrácení či reklamace:': 'Опишіть причину повернення або скарги:',
      'IBAN číslo účtu pro případné vrácení peněz:': 'Номер рахунку IBAN для можливого повернення коштів:',
      'Odeslat': 'Надіслати',
      'Číslo účtu pro případné vrácení peněz:': 'Номер рахунку для можливого повернення коштів:',
      'Kontaktní jméno:': 'Контактне імʼя:',
      'Kontaktní telefon:': 'Контактний телефон:',
      'Kontaktní email:': 'Контактна електронна адреса:',
      'Důvod vratky': 'Причина повернення',
      'Důvod vrácení': 'Причина повернення',
      'Prosíme rozepište důvod vrácení': 'Вкажіть причину повернення',
      'Prosím popište důvod vrácení zboží.': 'Опишіть причину повернення товарів.',
      'Bez čísla účtu': 'Без номера рахунку',
      'Nespravný IBAN. Zadejte jej prosím ve formátu XX1111111111 a zkontrolujte na překlepy.': 'Неправильний IBAN. Введіть його у форматі XX1111111111 та перевірте на помилки.',
      'Jméno': 'Імʼя',
      'Telefon': 'Телефон',
      'Kontaktní údaje': 'Контактні дані',
      'Prosím vyplňte kontaktní jméno.': 'Введіть контактне імʼя.',
      'Prosím vyplňte kontaktní telefon.': 'Введіть контактний телефон.',
      'Prosím vyplňte kontaktní email.': 'Введіть контактну електронну адресу.',
      'Označit k reklamaci': 'Позначити для скарги',
      'Označit k vrácení': 'Позначити для повернення',
      'Zrušit': 'Скасувати',
      'Speciální podmínky domluvené se zástupcem Bola': 'Спеціальні умови, узгоджені з представником Bola',
      'Uveďte jméno zástupce a domluvené podmínky': 'Вкажіть імʼя представника та узгоджені умови',
      'Prosím uveďte jméno zástupce a domluvené podmínky.': 'Вкажіть імʼя представника та узгоджені умови.',
      'Speciální podmínky domluvené se zástupcem Bola:': 'Спеціальні умови, узгоджені з представником Bola:',
      'Produkt ponechte v originální krabičce a tu zabalte do přepravní krabice (aby se nepoškodila krabice produktu).': 'Залишіть товар в оригінальній коробці та загорніть її в транспортувальну коробку (щоб не пошкодити коробку товару).',
      'Zadejte platný email ve formátu jmeno@domena.cz': 'Введіть дійсну електронну адресу у форматі імʼя@домен.ua'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    fallbackLng: false,
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;